<app-admin-header></app-admin-header>
    
<div class="transactions-container">
    <app-admin-sidebar></app-admin-sidebar>
  <h2>📋 All Transactions</h2>

  <!-- 🔍 Filter Bar -->
  <div class="filters">
    <input type="text" [(ngModel)]="search" (input)="filter()" placeholder="Search by drug, store or staff..." />

    <select [(ngModel)]="type" (change)="filter()">
      <option value="all">All</option>
      <option value="issue">Issued</option>
      <option value="transfer">Transferred</option>
      <option value="adjustment">Adjusted</option>
    </select>
  </div>

  <!-- 🧾 Transaction Table -->
  <table class="transactions-table">
    <thead>
      <tr>
        <th>Date</th>
        <th>Type</th>
        <th>Drug</th>
        <th>Quantity</th>
        <th>Store</th>
        <th>Staff</th>
        <th>Reason</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let t of filtered">
        <td>{{ t.date | date: 'short' }}</td>
        <td>{{ t.type | titlecase }}</td>
        <td>{{ t.drug_name }}</td>
        <td>{{ t.quantity }}</td>
        <td>{{ t.store_name }}</td>
        <td>{{ t.staff_name }}</td>
        <td>{{ t.reason || '-' }}</td>
      </tr>
    </tbody>
  </table>
</div>
